import { Button } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import StickyFooter from 'modules/menu/items/components/Item/ItemDetails/StickyFooter';

type OfferStickyFooterProps = {
  onCancel: () => void;
  isLoading: boolean;
};

const CancelButton = styled(Button).attrs({ size: 'small', variant: 'secondary' })`
  margin-inline-end: 16px;
`;

export const OfferStickyFooter = ({ onCancel, isLoading }: OfferStickyFooterProps) => {
  return (
    <StickyFooter>
      <CancelButton onClick={onCancel} type="button" disabled={isLoading}>
        <FormattedMessage id="state.cancel" />
      </CancelButton>
      <Button variant="primary" size="small" loading={isLoading} type="submit">
        <FormattedMessage id="state.save" />
      </Button>
    </StickyFooter>
  );
};
